import React from 'react';
import { NextPage, GetServerSideProps } from 'next';
import styled from 'styled-components';

import { Link as StyledLink } from '@makeship/core';
import Container from '../../components/Container';
import Head from '../../components/Head';
import { H1, H4Styles, H5, H6, P2 } from '../../components/Typography';
import { getPageByHandle } from '../../api/shop';
import { transformHtml } from '../../utils/htmr';
import { getPropsForPageLoad } from '../../utils/pageLoad';

const CookiesPolicyContainer = styled(Container)`
  padding: 48px 64px 72px 64px;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    padding: 24px 16px;
  }

  p + p,
  ul + p {
    margin-top: 16px;
  }
`;

const Heading = styled(H1)`
  text-transform: uppercase;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    ${H4Styles}
  }
`;

const SubHeading = styled(H6)`
  margin-top: 32px;
`;

const List = styled.ul``;

const ListItem = styled.li`
  margin-left: 1.5em;
  padding: 2px 0;

  &:before {
    content: '\\2022';
    color: ${({ theme }) => theme.colors.primary};
    font-weight: bold;
    display: inline-block;
    width: 1em;
    margin-left: -1em;
    font-size: 20px;
  }
`;

type CookiesPolicyPageType = {
  body: string;
};

const CookiesPolicyPage: NextPage<CookiesPolicyPageType> = ({ body }: CookiesPolicyPageType) => (
  <>
    <Head title="Cookies Policy" url="/policies/cookies-policy" />
    <CookiesPolicyContainer>
      {transformHtml(body, {
        h1: Heading,
        h5: H5,
        h6: SubHeading,
        p: P2,
        a: StyledLink.Primary,
        ul: List,
        li: ListItem,
      })}
    </CookiesPolicyContainer>
  </>
);

export const getServerSideProps: GetServerSideProps<CookiesPolicyPageType> = async (ctx) => {
  const page = await getPageByHandle('cookies');
  const propsForPageLoad = await getPropsForPageLoad(ctx);

  return {
    props: {
      body: page?.body,
      ...propsForPageLoad,
    },
  };
};

export default CookiesPolicyPage;
